import type { UserInfo } from '@/classes/UserInfo'
import dayjs from 'dayjs'

export function isInitDepositDoneOldUser(userInfo: UserInfo): boolean {
    const dateRangeStart = dayjs('2023-01-01')
    const dateRangeEnd = dayjs('2023-11-16')
    const registerDate = dayjs(userInfo.createdOn)
    return userInfo.isInitialDepositDone && registerDate >= dateRangeStart && registerDate < dateRangeEnd
}
